const renderBlock = (block: any) => {
    return <div></div>;
};

export default renderBlock;
